import { Controller } from "stimulus";
import "select2"
import {
    addHtmlElementClass,
    removeHtmlElementClass
} from "../utils/utils";


export default class extends Controller {
    static targets = [ "brand", "brandName", "brandCode" ];

    initialize() {
        this.handleChangeBrandId();
    }




    // Funzione che gestisce il rendering degli indirizzi utente sull'interfaccia grafica
    handleChangeBrandId() {
        if (this.brandTarget.value === 'other') {
            removeHtmlElementClass(document, "brand-name-container", "d-none");
            addHtmlElementClass(document, "brand-name-container", "d-flex");
        }
        else {
            removeHtmlElementClass(document, "brand-name-container", "d-flex");
            addHtmlElementClass(document, "brand-name-container", "d-none");
        }
    }
}